// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Loading from 'react-loading';
import { toast } from 'react-toastify';


import api from '../../api';

import formatDate from '../../utilities/formatDate';
import getSourceIcon from '../../utilities/getSourceIcon';

import '../../styles/recent.css';

export default class MostRecent extends React.Component {

    state = {
        docs: [],
        loading: false
    }

    actions = [
        {
            icon: "action-create.png",
            title: "Create a new stack",
            tooltip: "Create a new stack either from scratch or using a pre-trained model.",
            action: this.props.createStack,
            admin: false,
        },
        {
            icon: "action-retrain.png",
            title: "Retrain all stacks",
            tooltip: "Click this if you moved a bunch of files around or uploaded examples.",
            action: async () => await this.retrainAll(),
            admin: false
        }
    ]

    retrainAll = async () => {
        await this.props.loading();
        const res = await api.post('/stack/trainAll');
        if (res && res.success)
            toast.info("Started retraining all stacks. They will finish shortly.");
        else toast.error("Unable to retrain all stacks. Please try again later.");
        this.props.loaded();
    }

    componentDidMount = async () => {

        await this.setState({ loading: true });

        const parentHeight = this.refs.recent.parentElement.clientHeight-360;
        const numRecentToGet = Math.floor(parentHeight/95);

        const res = await api.get('/document/recent?limit=' + String(numRecentToGet));

        if (!res)
            return;

        if (res.success && res.recent)
            await this.setState({
                docs: res.recent,
                loading: false
            });

    }

    render = () => {

        const user = this.props.user ? this.props.user : { _id: null, isAdmin: false };

        return (<div ref="recent" className="recent">

            <h1>Most Recent Files</h1>

            {this.state.loading && <div style={{
                marginLeft: 12,
                marginTop: 20
            }}><Loading
                type="bubbles"
                color="var(--color-primary)"
                height={40}
                width={40}
            /></div>}

            {this.state.docs.map((doc,idx) => <div
                key={idx}
                className="recent-doc"
                style={idx===0 ? {
                    marginTop: 0
                } : {}}
            >
                <img
                    className="recent-thumbnail"
                    src={doc.thumbnail}
                    alt={doc.name}
                />

                <img
                    className="recent-source"
                    src={getSourceIcon(doc.source)}
                    alt={doc.source}
                />

                <div className="recent-meta">
                    <h2 onClick={() => this.props.history.push('/stack/' + (doc.stack ? doc.stack : 'unclassified') + '/document/' + doc._id)}>{doc.name}</h2>
                    <h3 onClick={() => this.props.history.push('/stack/' + (doc.stack ? doc.stack : 'unclassified'))} className={doc.path ? '' : 'accent-dark'}>{doc.path ? doc.path.replace(/\//g, " • ") : "Unclassified"}</h3>
                    Received on: {formatDate(doc.receivedOn)}
                </div>

            </div>)}

            {this.state.docs && this.state.docs.length === 0 && <div className="recent-info">
                <img
                    src="https://static.stax.ai/images/graphics/checklist.png"
                    alt="Checklist"
                />
                <p>
                    You don't have any documents on Stax yet. Click on your user icon and follow your checklist to complete your set up and get your email and faxes here automatically!
                </p>
                <p>
                    You can also upload documents to Stax by dragging them into the app.
                </p>
            </div>}

            {/* Meta actions */}
            <h1
                style={{
                    fontWeight: 500,
                    marginBottom: '-10px'
                }}
            >Actions</h1>

            {this.actions.filter(action => user.isAdmin || !action.admin)
                .map((action,idx) => <div
                className="meta-action"
                key={idx}
                title={action.tooltip}
                style={{
                    backgroundImage: "url('https://static.stax.ai/images/icons/" + action.icon,
                    marginLeft: '20px'
                }}
                onClick={action.action}
            >{action.title}</div>)}

        </div>);
    }

}